import React from 'react';
import { motion } from 'framer-motion';
import { workspacePanels } from '../../data/noetivra';
import { fadeUp } from '../../utils/motion';
export function NoetivraWorkspaces() {
  return <section aria-labelledby="workspaces-title" className="bg-surface-bg border-b border-line py-20 lg:py-24" data-id="element-1675" data-mp="1k0frzwvuhia1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1676" data-mp="1oyhdspknnvp7">
        <motion.div {...fadeUp} className="mb-12 max-w-2xl" data-id="element-1677" data-mp="1owwg4r31nwn4">
          <p className="text-sm font-medium text-teal mb-3" data-id="element-1678" data-mp="2cq682bh1eu8s">Government & Public Institutions · NCDS</p>
          <h2 id="workspaces-title" className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-1679" data-mp="2gpwxobutv4bq">
            Two workspaces, one shared record
          </h2>
        </motion.div>
        <motion.ul {...fadeUp} className="grid grid-cols-1 md:grid-cols-3 gap-px bg-line border border-line rounded-lg overflow-hidden" data-id="element-1680" data-mp="rbs3lsfsucs9">
          {workspacePanels.map((panel, index) => <li key={panel.title} className={`p-8 ${index === workspacePanels.length - 1 ? 'bg-navy-deep text-white' : 'bg-white'}`} data-id="element-1681" data-mp="23bgqc2qz38qd" data-mpi={index}>
              <h3 className={`font-heading font-bold text-xl mb-3 ${index === workspacePanels.length - 1 ? 'text-white' : 'text-ink-dark'}`} data-id="element-1682" data-mp="2da4v3zty5rc4">
                {panel.title}
              </h3>
              <p className={`leading-relaxed ${index === workspacePanels.length - 1 ? 'text-white/80' : 'text-ink-muted'}`} data-id="element-1683" data-mp="2mab2r52yrx3d">
                {panel.body}
              </p>
            </li>)}
        </motion.ul>
      </div>
    </section>;
}